import { render, staticRenderFns } from "./ResultReport.vue?vue&type=template&id=40b42f3d&"
import script from "./ResultReport.vue?vue&type=script&lang=js&"
export * from "./ResultReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports